
import { Device } from '../DeviceTypes';
import { mockSmartGasMeters } from '@/lib/mock-data/gas/smart-meters';
import { mapSmartMetersToDevices } from '../utils/deviceMappers';

// Create device objects from imported gas smart meters
export const gasSmartMeterDevices = mapSmartMetersToDevices(mockSmartGasMeters, 'Gas');

// Static Gas department devices
export const staticGasDevices: Device[] = [
  {
    id: 'GFC-2023-005',
    name: 'Gas Flow Controller 005',
    type: 'gas',
    category: 'Flow Controller',
    serial: 'GFC-2023-005',
    status: 'inactive',
    lastActive: '2023-09-20T14:45:00Z',
    department: 'Gas'
  },
  {
    id: 'GMF-2023-009',
    name: 'Gas Meter Flow 009',
    type: 'gas',
    category: 'Gas Meter',
    serial: 'GMF-2023-009',
    status: 'active',
    lastActive: '2023-10-16T11:35:00Z',
    department: 'Gas'
  },
  {
    id: 'GIG-2023-015',
    name: 'Gas IoT Gateway 015',
    type: 'gas',
    category: 'IoT Gateway',
    serial: 'GIG-2023-015',
    status: 'active',
    lastActive: '2023-10-15T09:25:00Z',
    department: 'Gas'
  },
  {
    id: 'GPS-2023-018',
    name: 'Gas Pressure Sensor 018',
    type: 'gas',
    category: 'Pressure Sensor',
    serial: 'GPS-2023-018',
    status: 'active',
    lastActive: '2023-10-16T13:50:00Z',
    department: 'Gas'
  },
  {
    id: 'GQM-2023-022',
    name: 'Gas Quality Monitor 022',
    type: 'gas',
    category: 'Quality Monitor',
    serial: 'GQM-2023-022',
    status: 'active',
    lastActive: '2023-10-17T10:40:00Z',
    department: 'Gas'
  },
  // Additional mapped devices that were previously unmapped
  {
    id: 'GAS-28461',
    name: 'Downtown Shopping Mall',
    type: 'gas',
    category: 'Smart Meter',
    serial: 'GAS-28461',
    status: 'active',
    lastActive: '2023-10-19T13:40:00Z',
    department: 'Gas'
  },
  {
    id: 'GAS-39284',
    name: 'Southside Golf & Country Club',
    type: 'gas',
    category: 'Smart Meter',
    serial: 'GAS-39284',
    status: 'inactive',
    lastActive: '2023-10-08T10:15:00Z',
    department: 'Gas'
  },
  {
    id: 'GAS-67823',
    name: 'Lakefront Water Park',
    type: 'gas',
    category: 'Smart Meter',
    serial: 'GAS-67823',
    status: 'active',
    lastActive: '2023-10-18T11:30:00Z',
    department: 'Gas'
  },
  {
    id: 'GAS-28473',
    name: 'University Recreation Center',
    type: 'gas',
    category: 'Smart Meter',
    serial: 'GAS-28473',
    status: 'active',
    lastActive: '2023-10-20T09:45:00Z',
    department: 'Gas'
  },
  {
    id: 'GAS-51392',
    name: 'Harbor View Restaurant',
    type: 'gas',
    category: 'Commercial',
    serial: 'GAS-51392',
    status: 'active',
    lastActive: '2023-10-17T15:20:00Z',
    department: 'Gas'
  },
  {
    id: 'GAS-84591',
    name: 'Northern Medical Center',
    type: 'gas',
    category: 'Institutional',
    serial: 'GAS-84591',
    status: 'active',
    lastActive: '2023-10-19T12:35:00Z',
    department: 'Gas'
  },
  {
    id: 'GAS-93726',
    name: 'Valley Hills Hotel',
    type: 'gas',
    category: 'Commercial',
    serial: 'GAS-93726',
    status: 'active',
    lastActive: '2023-10-16T14:25:00Z',
    department: 'Gas'
  },
  {
    id: 'GAS-17584',
    name: 'Central Recreation Center',
    type: 'gas',
    category: 'Municipal',
    serial: 'GAS-17584',
    status: 'active',
    lastActive: '2023-10-18T10:40:00Z',
    department: 'Gas'
  }
];

// All gas devices combined
export const allGasDevices: Device[] = [
  ...staticGasDevices,
  ...gasSmartMeterDevices
];
